import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState } from "react";
import { Tabs, Tab, Typography, Box, Tooltip } from "@mui/material";
import DetailsPageUpperLayer from "./DetailsPageUpperLayer";
import FourKitesIcon from "../../assets/FourKitesIcon.png";

const blueHighlight = "#00ADEF";
const theme = createTheme({
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 33,
          fontSize: "13.5px",
          textTransform: "none",
          padding: "0px 10px",
          border: "0.5px solid #ddd",
          backgroundColor: "#f2f3f4",
          color: "#000000",
          "&.Mui-selected": {
            backgroundColor: "#ffffff",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 33,
          backgroundColor: "#ffffff",
        },
      },
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      sx={{ borderRadius: "5px" }}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const UpperLayerTabLayout = ({
  firstHeading,
  secondHeading,
  thirdHeading,
  firstBoxData,
  secondBoxData,
  thirdBoxData,
  fkLink,
  title,
  showSecondTab = true,
  showThirdTab = true,
  showTrackAndTrace = false,
  fieldLabels = {}, 
}) => {
  const [value, setValue] = useState(0);

  const handleIconClick = () => {
    window.open(fkLink, "_blank");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabIndex = 0;
  const isValidFourKitesLink = fkLink && !fkLink.toLowerCase().includes("/eurl/null");
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ p: 0.8 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            mr: 2,
            gap: 1,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="black"
            textColor="black"
            aria-label="tabs"
          >
            <Tab label={firstHeading} {...a11yProps(tabIndex++)} />
            {showSecondTab && <Tab label={secondHeading} {...a11yProps(tabIndex++)} />}
            {showThirdTab && <Tab label={thirdHeading} {...a11yProps(tabIndex++)} />}
            {/* {showTrackAndTrace && <Tab label="Track & Trace" {...a11yProps(tabIndex++)} />} */}
          </Tabs>

          {showTrackAndTrace && isValidFourKitesLink && (
            <Tooltip title="Click to view detailed tracking information" arrow>
              <Box
                 onClick={handleIconClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  border: `1px solid ${blueHighlight}`,
                  borderRadius: "4px",
                  padding: "2px 6px",
                  marginBottom: "3px",
                  backgroundColor: "#e0f7fa",
                  "&:hover": {
                    backgroundColor: "#c3f3f9ff",
                  },
                  userSelect: "none",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "500",
                    color: blueHighlight,
                    marginRight: "6px",
                    fontSize: "14px",
                  }}
                >
                  FourKites
                </Typography>
                <img
                  src={FourKitesIcon}
                  alt="FourKites Icon"
                  style={{ width: 22, height: 23 }}
                />
              </Box>
            </Tooltip>
          )}
        </Box>

        <TabPanel value={value} index={0}>
          <DetailsPageUpperLayer
            hName={title}
            tabName={firstHeading}
            hProps={firstBoxData}
            fieldLabels={fieldLabels}
          />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <DetailsPageUpperLayer
            hName={title}
            tabName={secondHeading}
            hProps={secondBoxData}
            fieldLabels={fieldLabels}
          />
        </TabPanel>

        {showThirdTab && (
          <TabPanel value={value} index={2}>
            <DetailsPageUpperLayer
              hName={title}
              tabName={thirdHeading}
              hProps={thirdBoxData}
              fieldLabels={fieldLabels}
            />
          </TabPanel>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default UpperLayerTabLayout;
